export * from './insuranceDataUpload.component';



// WEBPACK FOOTER //
// ./src/app/InsuranceDataUpload/index.ts